import { validate } from "../utils/estimateValidation"
import { Link, useNavigate } from "react-router-dom"
import { useEffect, useRef, useState } from "react"
import "../css/Estimate.css"
import "../css/Contact.css"
import axios from "axios"
import { path } from "../utils/properties"
import ReCAPTCHA from 'react-google-recaptcha'
import Cookies from "js-cookie"


const Contact = () => {

    const [contact, setContact] = useState({ name: "", email: "", phone: "", institution: "", subject: "", message: "", accepted: false })
    const [sent, setSent] = useState(false)
    const [info, setInfo] = useState("")
    const navigate = useNavigate()
    const recaptcha = useRef()

    const [cookieConsent, setCookieConsent] = useState(false);

    useEffect(() => {
        const cookieConsent = Cookies.get("cookie-consent");
        if (cookieConsent) {
            const parsedCookie = JSON.parse(cookieConsent)
            if (parsedCookie["Advertising"]["consented"] && parsedCookie["Analytics"]["consented"] && parsedCookie["Social"]["consented"])
                setCookieConsent(true)
        }
    }, []);

    const handleValueChange = (e) => {
        const newContact = { ...contact }
        newContact[e.target.id] = e.target.value
        setContact(newContact)
    }

    /**/

    const handleAcceptChange = (e) => {
        const newContact = { ...contact }
        newContact[e.target.id] = e.target.checked
        setContact(newContact)
    }

    /**/

    const handleCreateContact = async (e) => {

        e.preventDefault()
        const captchaValue = recaptcha?.current.getValue()

        if (!captchaValue) {
            setInfo("Por favor, verifica el Captcha")
            return
        }


        const { isOk, resultMessage } = validate(contact)
        setInfo(resultMessage)
        if (!isOk) return

        const res = await axios.post('/api/verify', { captchaValue: captchaValue })
        const { data } = res

        if (!data.success) {
            setInfo('Error al validar Captcha')
            return
        }

        await axios.post(path + "/api/sendcontactmail/:mail", { contact: contact }).then(function (response) {
            const status = response.data.status
            const message = response.data.body
            if (status === "200") {
                setSent(true)
                window.scrollTo(0, 0)
            } else
                setInfo(message)
        })

    }


    if (sent)
        return (
            <main className="flex col h100 acenter mar-10 pad-30">
                <h2 className="jscenter cspica">viado el mensaje correctamente</h2>
                <img alt="Imagen" className="logo-200w" src="/images/estimates/check.gif" ></img>

                <section className="backlink acenter" onClick={() => navigate("/")}>
                    <section className="flex gap-10">
                        <i className="bi bi-arrow-left"></i>
                        <label className="pointer">Volver a la página principal</label>
                    </section>
                </section>

            </main>
        )


    return (
        <main className="flex col h100 acenter pad-30">
            <h2 className="jscenter cspica">Formulario de contacto</h2>

            <section className="flextocol pad-30 gap-20">
                <section className="flex col" >
                    <iframe className="map" title="Situación geográfica de Spica S.L." src="https://www.google.com/maps/embed?origin=mfe&pb=!1m4!2m1!1sSpica+sl,+ptl+valladares!5e0!6i15" frameBorder="0"></iframe>
                    <section className="contact-data">
                        <section className="pad-10 flex acenter gap-10">
                            <i className="bi bi-building-fill contact-icon"></i>
                            <section className="flex col">
                                <Link className="contact-text" to="https://www.google.com/maps/place/Spica/@42.1772356,-8.7076796,2585m/data=!3m1!1e3!4m14!1m7!3m6!1s0xd2f626659902e8d:0x2019c16dd3370e1!2sSpica!8m2!3d42.1772753!4d-8.7077023!16s%2Fg%2F1thxxhtn!3m5!1s0xd2f626659902e8d:0x2019c16dd3370e1!8m2!3d42.1772753!4d-8.7077023!16s%2Fg%2F1thxxhtn?entry=ttu&g_ep=EgoyMDI1MDQyMS4wIKXMDSoASAFQAw%3D%3D">PTL de Valladares. Calle C, nave C9</Link>
                                <Link className="contact-text" to="https://www.google.com/maps/place/Spica/@42.1772356,-8.7076796,2585m/data=!3m1!1e3!4m14!1m7!3m6!1s0xd2f626659902e8d:0x2019c16dd3370e1!2sSpica!8m2!3d42.1772753!4d-8.7077023!16s%2Fg%2F1thxxhtn!3m5!1s0xd2f626659902e8d:0x2019c16dd3370e1!8m2!3d42.1772753!4d-8.7077023!16s%2Fg%2F1thxxhtn?entry=ttu&g_ep=EgoyMDI1MDQyMS4wIKXMDSoASAFQAw%3D%3D">36315 Vigo, Pontevedra</Link>
                            </section>
                        </section>
                        <section className="pad-10 flex acenter gap-10">
                            <i className="bi bi-telephone-fill contact-icon"></i>
                            <label className="contact-text">+34 986 44 90 90</label>
                        </section>
                        <section className="pad-10 flex acenter gap-10">
                            <i className="bi bi-envelope-fill contact-icon"></i>
                            <label className="contact-text">spica@spica.es</label>
                        </section>
                        <section className="flex jcenter pad-10 gap-10">
                            <Link to="https://www.facebook.com/Spica-SL-273271465750/">
                                <i className="bi bi-facebook contact-icon-big pointer"></i>
                            </Link>
                            <Link to="https://twitter.com/spicasl">
                                <i className="bi bi-twitter-x contact-icon-big pointer"></i>
                            </Link>
                            <Link to="https://es.linkedin.com/company/spica-s-l-">
                                <i className="bi bi-linkedin contact-icon-big pointer"></i>
                            </Link>
                        </section>

                    </section>
                </section>

                {(cookieConsent) ?

                    <form className="flex col gap-10 acenter" onSubmit={handleCreateContact}>
                        <input maxLength="100" className="generic-input" id="name" type="text" placeholder="Nombre" onChange={handleValueChange} />
                        <input maxLength="100" className="generic-input" id="email" type="text" placeholder="Correo electrónico" onChange={handleValueChange} />
                        <input maxLength="15" className="generic-input" id="phone" type="text" placeholder="Teléfono" onChange={handleValueChange} />
                        <input maxLength="100" className="generic-input" id="institution" type="text" placeholder="Empresa / Institución" onChange={handleValueChange} />
                        <input maxLength="200" className="generic-input" id="subject" type="text" placeholder="Asunto" onChange={handleValueChange} />
                        <textarea maxLength="3000" className="generic-textarea" id="message" type="text" placeholder="Mensaje" onChange={handleValueChange} />
                        <label className="count">{contact.message.length}/3000</label>
                        <section className="flex gap-10 ">
                            <input id="accepted" type="checkbox" onChange={handleAcceptChange} />
                            <section >
                                <label>Acepto la </label>
                                <Link to="../politica-de-privacidad">Política de privacidad</Link>
                            </section>
                        </section>
                        <label className="cspica fade-in">{info}</label>
                        <ReCAPTCHA ref={recaptcha} sitekey={process.env.REACT_APP_SITE_KEY} />
                        <button className="wine-button pointer">Enviar</button>
                    </form>
                    :
                    <section className="flex col gap-10 acenter jcenter">
                        <article className="cookie-warning">
                            <label>Por favor, acepte las cookies para poder utilizar el formulario de contacto</label>
                        </article>
                    </section>}


            </section>
        </main>
    )
}

export default Contact

